module.exports = __webpack_public_path__ + "img/15.a0ce9f0f.jpg";